import { render, staticRenderFns } from "./Driver_master.vue?vue&type=template&id=b4067dbe&"
import script from "./Driver_master.vue?vue&type=script&lang=js&"
export * from "./Driver_master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports